import * as yup from 'yup';

import { strings } from '../strings';

export enum LoginField {
  Email = 'email',
  Password = 'password',
}

export const loginSchema = yup.object().shape({
  [LoginField.Email]: yup.string().trim().required(strings.authEmailRequired),
  [LoginField.Password]: yup.string().trim().required(strings.authPasswordRequired),
});
